var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, PCSS, ViewChild, Watch, PropertyConverters } from '@pacem/pacem-core';
import { Components as UIComponents } from '@pacem/pacem-ui';
const UI = UIComponents.UI;
/** @deprecated*/
let PacemCarouselElement = class PacemCarouselElement extends UI.PacemAdaptedIterativeElement {
    constructor() {
        super(...arguments);
        this.interval = 4000;
    }
};
__decorate([
    ViewChild(P + '-adapter')
], PacemCarouselElement.prototype, "adapter", void 0);
__decorate([
    ViewChild(P + '-slideshow')
], PacemCarouselElement.prototype, "slideshow", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemCarouselElement.prototype, "interval", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemCarouselElement.prototype, "pausable", void 0);
PacemCarouselElement = __decorate([
    CustomElement({
        tagName: P + '-carousel', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-repeater datasource="{{ :host.datasource }}">
        <${P}-slideshow class="${PCSS}-carousel" adapter="{{ ::adapter }}" index="{{ :host.index, twoway }}" on-load="this.focus()">

            <template>

                <${P}-slide class="${PCSS}-carousel-item" css-class="{{ { '${PCSS}-carousel-previous': :host.isPrevious(^index, ::slideshow.index), '${PCSS}-carousel-next': :host.isNext(^index, ::slideshow.index), '${PCSS}-carousel-focus': ^index === ::slideshow.index } }}">
                <${P}-a href="{{ ^item.url }}">
                    <${P}-img disabled="{{ !:host.isCloseTo(^index, ::slideshow.index) }}" class="${PCSS}-carousel-splash" adapt="cover" src="{{ ^item.image }}"></${P}-img>
                    <div class="${PCSS}-carousel-content">
                        <div class="${PCSS}-carousel-caption">
                            <h3><${P}-text text="{{ ^item.title }}"></${P}-text></h3>
                            <${P}-panel class="paragraph" content="{{ ^item.content }}"></${P}-panel>
                        </div>
                    </div>
                </${P}-a>
                </${P}-slide>

            </template>
        </${P}-slideshow>

    </${P}-repeater><${P}-adapter pausable="{{ :host.pausable }}" class="${PCSS}-carousel-adapter" interval="{{ :host.interval }}"></${P}-adapter>`
    })
], PacemCarouselElement);
export { PacemCarouselElement };
